require('./index.css');
let request = require('@common/request');
let mask = require('../mask/index');

$(function () {//初始化 老虎机

  window.hintMail = function () {return;
    mask('littleFollow','','请确保安装了outlook或其他EMail软件')
  }
});



// WEBPACK FOOTER //
// ./modules/contact/index.js